import { parse } from 'qs';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export const useFamilyTariffFromQuery = (): boolean => {
    const { search } = useLocation();
    const queryParams = parse(search, { ignoreQueryPrefix: true });
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const userCondition = !isCorpUser && !isBizUser && !isPaidUser;
    const isMobile = EnvironmentSelectors.isMobile();

    return queryParams?.family === '1' && userCondition && !isMobile;
};
